export enum Roles {
    None = 0,
    Admin = 1,
    Moderator = 2,
    SLT = 3,
    User = 4,
    SuperAdmin = 5,
    CaseyTA=6,
    State=7,
    SurveyReportViewer=8,
    QuantDataViewer=9,
    QuantDataOwner=10,
    CaseyAllSites=14
}
